import React from "react";

import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useGetCategoryOptionsQuery } from "../api/GetOptions";

export default function useGetOptionHook(categoryId: number | undefined) {
    const { showNotification } = useUtilitiesContext();

    const {
        data: options,
        isError: isOptionsError,
        error: optionsError,
        isFetching: isOptionsFetching,
        refetch: refetchOptions
    } = useGetCategoryOptionsQuery(categoryId);

    React.useEffect(() => {
        if (isOptionsError) {
            showNotification({
                type: "error",
                title: "Error",
                message: optionsError.message,
            });
        }
    }, [isOptionsError, optionsError, showNotification]);

    return {
        options,
        isOptionsFetching,
        refetchOptions
    };
}